import React from "react";
import { Megaphone, Cpu, ClipboardCheck, BarChart3 } from "lucide-react";

const steps = [
  {
    icon: Megaphone,
    title: "Publique su vacante",
    desc: "Cree su oferta en Nexus ATS y publique automáticamente en +17 job boards con un clic.",
  },
  {
    icon: Cpu,
    title: "La IA filtra por usted",
    desc: "El sistema analiza cada aplicación y ordena los candidatos según el perfil que usted definió.",
  },
  {
    icon: ClipboardCheck,
    title: "Evalúe con psicometría",
    desc: "Envíe evaluaciones psicométricas con un clic. Solo los candidatos que califican avanzan en el pipeline.",
  },
  {
    icon: BarChart3,
    title: "Decida con datos",
    desc: "Agenda entrevistas desde la plataforma y tome la decisión con el historial completo de cada candidato.",
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section id="como-funciona" style={{ background: "#F8F7FF", paddingTop: "80px", paddingBottom: "80px" }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span
            className="inline-block px-4 py-1.5 rounded-full text-xs font-bold tracking-wider text-white mb-4"
            style={{ background: "#620AE2" }}
          >
            CÓMO FUNCIONA
          </span>
          <h2
            className="font-exo font-bold mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 3rem)", color: "#1A1A2E" }}
          >
            Cómo funciona Nexus ATS
          </h2>
          <p className="text-base text-muted-foreground">
            Una plataforma que centraliza todo su reclutamiento y le devuelve el control del proceso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all border border-purple-100"
            >
              <div
                className="absolute -top-4 -left-4 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm"
                style={{ background: "#620AE2" }}
              >
                {String(i + 1).padStart(2, "0")}
              </div>
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                style={{ background: "rgba(0, 201, 212, 0.15)" }}
              >
                <s.icon className="h-6 w-6" style={{ color: "#620AE2" }} />
              </div>
              <h3 className="font-bold text-lg mb-2" style={{ color: "#1A1A2E" }}>
                {s.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
